// TaskTooltip.tsx
import { Tooltip, Box, Text, Flex } from "@chakra-ui/react";
import React from "react";
import { format } from "date-fns";

interface TaskTooltipProps {
  task: any;
  type: "planned" | "actual";
  isSubtask?: boolean;
  children: React.ReactNode;
}

const TaskTooltip: React.FC<TaskTooltipProps> = ({ task, type, isSubtask = false, children }) => {
  return (
    <Tooltip
      hasArrow
      placement="top"
      bg="white"
      color="black"
      boxShadow="md"
      borderRadius="md"
      p={3}
      zIndex={10}
      label={
        <Box>
          <Flex align="center" mb={2}>
            <Box
              w="8px"
              h="8px"
              bg={type === "planned" ? "blue.400" : "green.400"}
              borderRadius="full"
              mr={2}
            />
            <Text fontWeight="bold" fontSize="md" color="gray.700">
              {type === "planned"
                ? isSubtask
                  ? "Planned Subtask Details"
                  : "Planned Task Details"
                : isSubtask
                ? "Actual Subtask Details"
                : "Actual Task Details"}
            </Text>
          </Flex>
          <Text fontSize="sm" color="gray.600">
            <b>{isSubtask ? "Subtask Name:" : "Task Name:"}</b> {task.name}
          </Text>
          <Text fontSize="sm" color="gray.600">
            <b>Progress:</b> {Math.round(task.progress)}%
          </Text>
          <Text fontSize="sm" color="gray.600">
            <b>{type === "planned" ? "Planned Start" : "Actual Start"}:</b>{" "}
            {(() => {
              const d = new Date(type === "planned" ? task.plannedStart : task.actualStart);
              return isNaN(d.getTime()) ? "N/A" : format(d, "dd/MM/yyyy");
            })()}
          </Text>
          <Text fontSize="sm" color="gray.600">
            <b>{type === "planned" ? "Planned End" : "Actual End"}:</b>{" "}
            {(() => {
              const d = new Date(type === "planned" ? task.plannedEnd : task.actualEnd);
              return isNaN(d.getTime()) ? "N/A" : format(d, "dd/MM/yyyy");
            })()}
          </Text>
        </Box>
      }
    >
      {children}
    </Tooltip>
  );
};

export default TaskTooltip;
